import { styled } from '@mui/material/styles';

export const SlideWrapper = styled('div')(({ theme }) => ({
	'.masthead__section': {
		position: 'relative',
		minHeight: '100vh',
		marginBottom: '1rem',
		[theme.breakpoints.down('laptop')]: {
			minHeight: '730px',
			backgroundPosition: 'center',
		},
	},
	'.masthead__container': {
		position: 'absolute',
		paddingTop: '207px',
		paddingBottom: '105px',
		width: '100%',
		marginBottom: 'auto',
		top: 0,
		zIndex: 2,
		[theme.breakpoints.down('laptop')]: {
			paddingTop: '180px',
			paddingBottom: '159px',
			backgroundPosition: 'center',
		},
	},
	'.masthead__wrapper': {
		width: '100%',
		height: '100vh',
		margin: 0,
		overflow: 'hidden',
		position: 'relative',
		'&::after': {
			content: '""',
			position: 'absolute',
			width: '100%',
			height: '100%',
			background: 'rgba(15, 35, 69, .7)',
			zIndex: 1,
			left: 0,
			top: 0,
		},
	},
	'.masthead__video': {
		height: '100%',
		objectFit: 'cover',
		width: '100%',
		pointerEvents: 'none',
		zIndex: 3,
		'&.mobile': {
			display: 'block',
			[theme.breakpoints.up('sm')]: {
			 	display: 'none',
			},
		},
		'&.desktop': {
			display: 'none',
			[theme.breakpoints.up('sm')]: {
				display: 'block',
			}
		}
	},
	'.masthead__content': {
		zIndex: 4,
		opacity: 0,
		position: 'relative',
		'&.active': {
			opacity: 1,
			animation: 'loopOpacity 7s ease-in-out forwards',
		},
		// '&.index-0': {
		// 	animation: 'initialLoopOpacity 7s ease-in-out forwards',
		// },
	},
	'.masthead__title': {
		paddingTop: '112px',
		paddingBottom: '69px',
		[theme.breakpoints.down('laptop')]: {
			paddingTop: '1rem',
		},
		[theme.breakpoints.between('sm', 'md')]: {
			paddingTop: '100px',
		}
	},
	'.masthead__link': {
		[theme.breakpoints.down('laptop')]: {
			width: '100%',
		},
	},
}));

const styles = {};

export default styles;